import logo from "../assets/logo.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { Collapse, Dropdown } from "flowbite";
import AOS from "aos";
import image1 from "../assets/avatar/user.png"
import menu1 from "../assets/menus/1.jpg"
import menu2 from "../assets/menus/2.jpg"

import offer1 from "../assets/offers/1.jpg"
import offer2 from "../assets/offers/2.jpg"

import gimg1 from "../assets/galleryimages/pizza.jpg"
import gimg2 from "../assets/galleryimages/burger.jpg"
import gimg3 from "../assets/galleryimages/sandwich.jpg"
import gimg4 from "../assets/galleryimages/brownie.jpg"



const HomePage = ({ data }) => {

  React.useEffect(() => {
    AOS.init({
      offset: 100,
      duration: 500,
      easing: "ease-in-sine",
      delay: 100,
    });
    AOS.refresh();
  }, []);

  let getYear = () => {
    let currentYear = new Date().getFullYear();
    return currentYear;
  };


  const target = useRef(null);
  const trigger = useRef(null);
  const navigate1 = useNavigate();
  const location = useLocation();
  const [bool, setbool] = useState(false);

  const boolfunc = () => {
    setbool(true);
    mobile();
  };

  //Mobile Navbar func
  const mobile = () => {
    const hammenu = target.current;
    const nav = trigger.current;

    const navoptions = {
      onCollapse: () => { },
      onExpand: () => { },
      onToggle: () => { },
    };
    const mobnav = new Collapse(hammenu, nav, navoptions);
    mobnav.expand();
    mobnav.collapse();

    if (bool == true) {
      mobnav.collapse();
    }
  };

  useEffect(() => {
    mobile();
  }, []);




  return (
    <div>

      <nav className="bg-white dark:bg-white-900  w-full z-20 p-1.5 top-0 left-0 border-b border-gray-200 dark:border-gray-600  ">
        <div className="xl:container m-auto px-6 md:px-12">
          <div className="flex flex-wrap items-center justify-between gap-6 md:py-3 md:gap-0">
            <div className="w-full flex justify-between lg:w-auto">
              <a href="/" className="flex items-center">
                <img src={logo} className="h-10 mr-4" alt=" Logo" />
                <span className="text-3xl text-black font-pfont font-extrabold">Peacock <span className="text-porange">Cafe</span></span>
              </a>
              <div className="flex md:order-2 overflow-hidden">
                <button
                  data-collapse-toggle="navbar-sticky"
                  id="hammenu"
                  ref={trigger}
                  type="button"
                  className="inline-flex items-center p-2 text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600 overflow-visible"
                  aria-controls="navbar-sticky"
                  aria-expanded="false"
                >
                  <span className="sr-only">Open main menu</span>
                  <svg
                    className="w-6 h-6"
                    aria-hidden="true"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                </button>
              </div>
            </div>
            <div
              className="items-center justify-between hidden w-full md:flex md:w-auto md:order-1"
              id="navbar-sticky"
              aria-current="page"
              ref={target} >
              <div className="w-full space-y-2 border-primary/10 dark:border-gray-700 flex flex-col -ml-1 sm:flex-row lg:space-y-0 md:w-max   ">
                <a href="/"
                  className="text-black hover:bg-porange hover:rounded-md hover:text-white font-semibold font-poppins block px-4 py-2 pl-3 pr-4
                          text-lg">Home</a>
                <a href="#offers"
                  className="text-black hover:bg-porange hover:rounded-md hover:text-white font-semibold font-poppins block px-4 py-2 pl-3 pr-4
                          text-lg">Offers</a>
                <a href="#ofers"
                  className="text-black hover:bg-porange hover:rounded-md hover:text-white font-semibold font-poppins block px-4 py-2 pl-3 pr-4
                          text-lg">Online Orders</a>
                <a href="#menu"
                  className="text-black hover:bg-porange hover:rounded-md hover:text-white font-semibold font-poppins block px-4 py-2 pl-3 pr-4
                          text-lg">Cafe Menu</a>

                <a href="#gallery"
                  className="text-black hover:bg-porange hover:rounded-md hover:text-white font-semibold font-poppins block px-4 py-2 pl-3 pr-4 
                         text-lg">Gallery</a>

                <a href="#contact"
                  className="text-black hover:bg-porange hover:rounded-md hover:text-white font-semibold font-poppins block px-4 py-2 pl-3 pr-4 
                         text-lg">Contact</a>

              </div>

            </div>
          </div>
        </div>
      </nav>


      <section className="" id="menu">
        <h4 className="text-center font-extrabold text-3xl mt-10 font-pfont md:text-3xl lg:text-5xl  mb-5  text-porange ">
          Peacock Cafe Menus.
        </h4>
        <p className="lg:text-2xl md:text-xl font-bold text-black text-center  font-Kalam">Explore the best Taste with us.</p>
        <div class="grid grid-cols-1 gap-2 m-5">
          <div>
            <img class="h-auto max-w-full rounded-lg" src={menu1} alt="menu" />
          </div>
          <div>
            <img class="h-auto max-w-full rounded-lg" src={menu2} alt="menu1" />
          </div>
        </div>
      </section>

      <section className="lg:mt-20 " id="offers">
        <h4 className="text-center font-extrabold text-3xl mt-10 font-pfont md:text-3xl lg:text-5xl  mb-5  text-porange ">
          Peacock Cafe Offers.
        </h4>
        <p className="lg:text-2xl md:text-xl font-bold text-black text-center font-Kalam ">Taste our best foods with our Wednesday Offer.</p>
        <div class="grid grid-cols-2 gap-2 m-5">
          <div>
            <img class="h-auto max-w-full rounded-lg" src={offer1} alt="offer1" />
          </div>
          <div>
            <img class="h-auto max-w-full rounded-lg" src={offer2} alt="offer" />
          </div>
        </div>
      </section>


      <div className="bg-white lg:mt-20 " id="gallery">
        <div className="mx-auto max-w-screen-2xl px-4 md:px-8">
          <div className="mb-10 md:mb-16">
            <h4 className="text-center font-extrabold text-3xl mt-10 font-pfont md:text-3xl lg:text-5xl  mb-5  text-porange ">
              Peacock Cafe Best Dishes.
            </h4>
            <p className="lg:text-2xl md:text-xl font-bold text-black text-center font-Kalam ">Taste our best foods with our Exciting Offers.</p>
          </div>
          <div className="grid gap-x-4 gap-y-8 sm:grid-cols-2 md:gap-x-6 lg:grid-cols-3 xl:grid-cols-4">
            <div>
              <a className="group relative mb-2 block h-96 overflow-hidden rounded-lg bg-gray-100 shadow-lg lg:mb-3">
                <img src={gimg1} loading="lazy" alt="Photo by Austin Wade" className="h-full w-full object-cover object-center transition duration-200 group-hover:scale-110" />
              </a>
            </div>
            <div>
              <a className="group relative mb-2 block h-96 overflow-hidden rounded-lg bg-gray-100 shadow-lg lg:mb-3">
                <img src={gimg2} loading="lazy" alt="Photo by Nick Karvounis" className="h-full w-full object-cover object-center transition duration-200 group-hover:scale-110" />
              </a>
            </div>
            <div>
              <a className="group relative mb-2 block h-96 overflow-hidden rounded-lg bg-gray-100 shadow-lg lg:mb-3">
                <img src={gimg3} loading="lazy" alt="Photo by Austin Wade" className="h-full w-full object-cover object-center transition duration-200 group-hover:scale-110" />
              </a>
            </div>
            <div>
              <a className="group relative mb-2 block h-96 overflow-hidden rounded-lg bg-gray-100 shadow-lg lg:mb-3">
                <img src={gimg4} loading="lazy" alt="Photo by Vladimir Fedotov" className="h-full w-full object-cover object-center transition duration-200 group-hover:scale-110" />
              </a>
            </div>


          </div>
        </div>
      </div>


      <div className="container  mx-auto px-2 md:px-6  " id="contact">

        <section className=" text-gray-800 m-5">
          <h4 className="text-center font-extrabold text-3xl mt-10 font-pfont md:text-3xl lg:text-5xl  mb-5  text-porange ">
            Get in touch.
          </h4>
          <p className="lg:text-2xl md:text-xl mb-10 font-medium text-black text-center font-Kalam"> Connect with us. or feel free to just send us a email. We won't mind!</p>

          <div className="md:flex md:flex-wrap">
            <div className="xl:w-6/12 md:w-7/12 mb-6 lg:mb-0 md:pr-3">

              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3889.1546765692583!2d77.61628186886333!3d12.897773788696426!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae1500739e7889%3A0x595d7d637145edea!2sPeacock%20Cafe!5e0!3m2!1sen!2sin!4v1706161967115!5m2!1sen!2sin"
                width="600" height="450"
                className="h-80 w-full border-0 rounded-lg shadow-lg"
                allowfullscreen="" loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"></iframe>
            </div>
            <div className="xl:w-6/12 md:w-5/12 md:pl-3">
              <div className="grid xl:grid-cols-2 xl:grid-rows-2 xl:gap-x-4 md:gap-x-6">
                <div className="mb-10 md:mb-12">
                  <div className="flex items-start">
                    <div className="shrink-0">
                      <div className="p-4 bg-porange rounded-md shadow-md w-14 h-14 flex items-center justify-center">
                        <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="headset" className="w-5 text-white" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                          <path fill="currentColor" d="M192 208c0-17.67-14.33-32-32-32h-16c-35.35 0-64 28.65-64 64v48c0 35.35 28.65 64 64 64h16c17.67 0 32-14.33 32-32V208zm176 144c35.35 0 64-28.65 64-64v-48c0-35.35-28.65-64-64-64h-16c-17.67 0-32 14.33-32 32v112c0 17.67 14.33 32 32 32h16zM256 0C113.18 0 4.58 118.83 0 256v16c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-16c0-114.69 93.31-208 208-208s208 93.31 208 208h-.12c.08 2.43.12 165.72.12 165.72 0 23.35-18.93 42.28-42.28 42.28H320c0-26.51-21.49-48-48-48h-32c-26.51 0-48 21.49-48 48s21.49 48 48 48h181.72c49.86 0 90.28-40.42 90.28-90.28V256C507.42 118.83 398.82 0 256 0z"></path>
                        </svg>
                      </div>
                    </div>
                    <div className="grow ml-6">
                      <p className="font-bold mb-1">Technical support</p>
                      <a href="mailto:teammakingminds@gmail.com"
                        rel="noreferrer"
                        target="_blank" className="text-black">teammakingminds@gmail.com</a><br />
                      <a href="https://wa.me/919566344051" target="_blank" rel="noreferrer" className="text-black">9566344051</a>
                    </div>
                  </div>
                </div>
                <div className="mb-10 md:mb-12">
                  <div className="flex items-start">
                    <div className="shrink-0">
                      <div className="p-4 bg-porange rounded-md shadow-md w-14 h-14 flex items-center justify-center">
                        <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="dollar-sign" className="w-3 text-white" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512"><path fill="currentColor" d="M209.2 233.4l-108-31.6C88.7 198.2 80 186.5 80 173.5c0-16.3 13.2-29.5 29.5-29.5h66.3c12.2 0 24.2 3.7 34.2 10.5 6.1 4.1 14.3 3.1 19.5-2l34.8-34c7.1-6.9 6.1-18.4-1.8-24.5C238 74.8 207.4 64.1 176 64V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48h-2.5C45.8 64-5.4 118.7.5 183.6c4.2 46.1 39.4 83.6 83.8 96.6l102.5 30c12.5 3.7 21.2 15.3 21.2 28.3 0 16.3-13.2 29.5-29.5 29.5h-66.3C100 368 88 364.3 78 357.5c-6.1-4.1-14.3-3.1-19.5 2l-34.8 34c-7.1 6.9-6.1 18.4 1.8 24.5 24.5 19.2 55.1 29.9 86.5 30v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48.2c46.6-.9 90.3-28.6 105.7-72.7 21.5-61.6-14.6-124.8-72.5-141.7z"></path></svg>
                      </div>
                    </div>
                    <div className="grow ml-6">
                      <p className="font-bold mb-1">Sales questions</p>
                      <a href="mailto:rm.barath2000@gmail.com"
                        rel="noreferrer"
                        target="_blank" className="text-black">rm.barath2000@gmail.com</a><br />
                      <a href="https://wa.me/916380201647" target="_blank" rel="noreferrer" className="text-black">6380201647</a>
                    </div>
                  </div>
                </div>
                <div className="mb-10 md:mb-12">
                  <div className="flex align-start">
                    <div className="shrink-0">
                      <div className="p-4 bg-porange rounded-md shadow-md w-14 h-14 flex items-center justify-center">
                        <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="newspaper" className="w-5 text-white" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="currentColor" d="M552 64H88c-13.255 0-24 10.745-24 24v8H24c-13.255 0-24 10.745-24 24v272c0 30.928 25.072 56 56 56h472c26.51 0 48-21.49 48-48V88c0-13.255-10.745-24-24-24zM56 400a8 8 0 0 1-8-8V144h16v248a8 8 0 0 1-8 8zm236-16H140c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm208 0H348c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm-208-96H140c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm208 0H348c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm0-96H140c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h360c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12z"></path></svg>
                      </div>
                    </div>
                    <div className="grow ml-6">
                      <p className="font-bold mb-1">Press</p>
                      <a href="mailto:rm.barath2000@gmail.com"
                        rel="noreferrer"
                        target="_blank" className="text-black">rm.barath2000@gmail.com</a><br />
                      <a href="https://wa.me/916380201647" target="_blank" rel="noreferrer" className="text-black">6380201647</a>
                    </div>
                  </div>
                </div>
                <div className="mb-10 md:mb-12">
                  <div className="flex align-start">
                    <div className="shrink-0">
                      <div className="p-4 bg-porange rounded-md shadow-md w-14 h-14 flex items-center justify-center">
                        <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="bug" className="w-5 text-white" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M511.988 288.9c-.478 17.43-15.217 31.1-32.653 31.1H424v16c0 21.864-4.882 42.584-13.6 61.145l60.228 60.228c12.496 12.497 12.496 32.758 0 45.255-12.498 12.497-32.759 12.496-45.256 0l-54.736-54.736C345.886 467.965 314.351 480 280 480V236c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v244c-34.351 0-65.886-12.035-90.636-32.108l-54.736 54.736c-12.498 12.497-32.759 12.496-45.256 0-12.496-12.497-12.496-32.758 0-45.255l60.228-60.228C92.882 378.584 88 357.864 88 336v-16H32.666C15.23 320 .491 306.33.013 288.9-.484 270.816 14.028 256 32 256h56v-58.745l-46.628-46.628c-12.496-12.497-12.496-32.758 0-45.255 12.498-12.497 32.758-12.497 45.256 0L141.255 160h229.489l54.627-54.627c12.498-12.497 32.758-12.497 45.256 0 12.496 12.497 12.496 32.758 0 45.255L424 197.255V256h56c17.972 0 32.484 14.816 31.988 32.9zM257 0c-61.856 0-112 50.144-112 112h224C369 50.144 318.856 0 257 0z"></path></svg>
                      </div>
                    </div>
                    <div className="grow ml-6">
                      <p className="font-bold mb-1">Bug report</p>
                      <a href="mailto:teammakingminds@gmail.com"
                        rel="noreferrer"
                        target="_blank" className="text-black">teammakingminds@gmail.com</a><br />
                      <a href="https://wa.me/919566344051" target="_blank" rel="noreferrer" className="text-black">9566344051</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </section>

      </div>

      <footer className="bg-white border-t border-gray-300">
        <div className="mx-auto max-w-screen-xl px-4 pb-6 pt-16 sm:px-6 lg:px-8 lg:pt-24">
          <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
            <div>
              <div className="flex justify-center text-black font-medium sm:justify-start">
                <a
                  onClick={() =>
                    navigate1({
                      pathname: `${process.env.PUBLIC_URL}/`,
                    })
                  }
                  className="flex items-center cursor-pointer  "
                >
                  <img src={logo} className="h-8 mr-5" alt="logo" />
                  <span className="text-3xl text-black font-pfont font-extrabold">Peacock <span className="text-porange">Cafe</span></span>
                </a>
              </div>

              <p className="mt-6 max-w-md text-center leading-relaxed text-black sm:max-w-xs sm:text-left text-lg font-medium">
                Dhanalakshmi Enterprises,
                No.30/3/1, Site No.1,
                Near Axis Bank
                Kodichikkanahalli Village,
                Bommanahalli,
                Bangalore - 560068.

              </p>
              <ul className="mt-8 flex justify-center gap-6 sm:justify-start md:gap-8">
                {/* <li>
                  <a
                    href="/"
                    rel="noreferrer"
                    target="_blank"
                    className="text-black transition hover:text-gray-700"
                  >
                    <span className="sr-only">Facebook</span>
                    <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                      <path
                        fill-rule="evenodd"
                        d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"
                        clip-rule="evenodd"
                      />
                    </svg>
                  </a>
                </li> */}

                <li>
                  <a
                    href="https://www.instagram.com/peacockcafe_24?igsh=MWhtajY5aXBlZ3VtZw=="
                    rel="noreferrer"
                    target="_blank"
                    className="text-black transition hover:text-gray-700"
                  >
                    <span className="sr-only">Instagram</span>
                    <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                      <path
                        fill-rule="evenodd"
                        d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"
                        clip-rule="evenodd"
                      />
                    </svg>
                  </a>
                </li>

                <li>
                  <a
                    href="https://wa.me/919880618779"
                    rel="noreferrer"
                    target="_blank"
                    className="text-black transition hover:text-gray-700"
                  >
                    <span className="sr-only">whats app</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M6.014 8.00613C6.12827 7.1024 7.30277 5.87414 8.23488 6.01043L8.23339 6.00894C9.14051 6.18132 9.85859 7.74261 10.2635 8.44465C10.5504 8.95402 10.3641 9.4701 10.0965 9.68787C9.7355 9.97883 9.17099 10.3803 9.28943 10.7834C9.5 11.5 12 14 13.2296 14.7107C13.695 14.9797 14.0325 14.2702 14.3207 13.9067C14.5301 13.6271 15.0466 13.46 15.5548 13.736C16.3138 14.178 17.0288 14.6917 17.69 15.27C18.0202 15.546 18.0977 15.9539 17.8689 16.385C17.4659 17.1443 16.3003 18.1456 15.4542 17.9421C13.9764 17.5868 8 15.27 6.08033 8.55801C5.97237 8.24048 5.99955 8.12044 6.014 8.00613Z" fill="#0F0F0F" />
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M12 23C10.7764 23 10.0994 22.8687 9 22.5L6.89443 23.5528C5.56462 24.2177 4 23.2507 4 21.7639V19.5C1.84655 17.492 1 15.1767 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23ZM6 18.6303L5.36395 18.0372C3.69087 16.4772 3 14.7331 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C11.0143 21 10.552 20.911 9.63595 20.6038L8.84847 20.3397L6 21.7639V18.6303Z" fill="#0F0F0F" />
                    </svg>
                  </a>
                </li>

                <li>
                  <a
                    href="mailto:peacockcafeservice@gmail.com"
                    rel="noreferrer"
                    target="_blank"
                    className="text-black transition hover:text-gray-700"
                  >
                    <span className="sr-only">mail</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M14.5 9.50012H9.5M3.02832 10.0001L10.2246 14.8167C10.8661 15.2444 11.1869 15.4582 11.5336 15.5413C11.8399 15.6147 12.1593 15.6147 12.4657 15.5413C12.8124 15.4582 13.1332 15.2444 13.7747 14.8167L20.971 10.0001M10.2981 4.06892L4.49814 7.71139C3.95121 8.05487 3.67775 8.2266 3.4794 8.45876C3.30385 8.66424 3.17176 8.90317 3.09111 9.16112C3 9.45256 3 9.77548 3 10.4213V16.8001C3 17.9202 3 18.4803 3.21799 18.9081C3.40973 19.2844 3.71569 19.5904 4.09202 19.7821C4.51984 20.0001 5.0799 20.0001 6.2 20.0001H17.8C18.9201 20.0001 19.4802 20.0001 19.908 19.7821C20.2843 19.5904 20.5903 19.2844 20.782 18.9081C21 18.4803 21 17.9202 21 16.8001V10.4213C21 9.77548 21 9.45256 20.9089 9.16112C20.8282 8.90317 20.6962 8.66424 20.5206 8.45876C20.3223 8.2266 20.0488 8.05487 19.5019 7.71139L13.7019 4.06891C13.0846 3.68129 12.776 3.48747 12.4449 3.41192C12.152 3.34512 11.848 3.34512 11.5551 3.41192C11.224 3.48747 10.9154 3.68129 10.2981 4.06892Z" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </a>
                </li>

              </ul>
            </div>

            <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 md:grid-cols-4 lg:col-span-2">
              <div className="text-center sm:text-left">
                <p className="text-lg font-medium text-gray-900 lg:no-underline underline">About Us</p>

                <ul className="mt-8 space-y-4 text-sm">
                  <li>
                    <a className="text-black font-medium transition hover:text-gray-700/75" href="/">
                      Company History
                    </a>
                  </li>

                  <li>
                    <a className="text-black font-medium transition hover:text-gray-700/75" href="/">
                      About Us
                    </a>
                  </li>


                </ul>
              </div>

              <div className="text-center sm:text-left">
                <p className="text-lg font-medium text-gray-900 lg:no-underline underline">Our Services</p>

                <ul className="mt-8 space-y-4 text-sm">

                  <li>
                    <a href="#gallery" className="text-black font-medium transition hover:text-gray-700/75" >  Gallery </a>
                  </li>

                  <li>
                    <a className="text-black font-medium transition hover:text-gray-700/75" href="#menu"> Menus </a>
                  </li>


                </ul>
              </div>

              <div className="text-center sm:text-left">
                <p className="text-lg font-medium text-gray-900 lg:no-underline underline">Legal</p>

                <ul className="mt-8 space-y-4 text-sm">
                  <li>
                    <a className="text-black font-medium transition hover:text-gray-700/75" href="/">  Terms & Conditions </a>
                  </li>

                  <li>
                    <a className="text-black font-medium transition hover:text-gray-700/75" href="/">  Privacy Policy </a>
                  </li>
                </ul>
              </div>

              <div className="text-center sm:text-left">
                <p className="text-lg font-medium text-gray-900 lg:no-underline underline">Contact Us</p>

                <ul className="mt-8 space-y-4 text-sm">
                  <li>
                    <a className="flex items-center justify-center gap-1.5 ltr:sm:justify-start rtl:sm:justify-end" href="/" >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5 shrink-0 text-gray-900"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        stroke-width="2"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                        />
                      </svg>

                      <a href="mailto:peacockcafeservice@gmail.com" target="_blank" rel="noreferrer" className="flex-1 text-black font-medium cursor-pointer">peacockcafeservice@gmail.com</a>
                    </a>
                  </li>

                  <li>
                    <a className="flex items-center justify-center gap-2.5 ltr:sm:justify-start rtl:sm:justify-end"  >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5 shrink-0 text-gray-900"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        stroke-width="2"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                        />
                      </svg>

                      <a href="https://wa.me/919880618779" target="_blank" rel="noreferrer" className="flex-1 text-black font-medium cursor-pointer">98806 18779</a>
                    </a>
                  </li>

                  <li className="flex items-start justify-center gap-1.5 ltr:sm:justify-start rtl:sm:justify-end"  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5 shrink-0 text-gray-900"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      stroke-width="2"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                      />
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                      />
                    </svg>

                    <address className="-mt-0.5 flex-1 not-italic text-black font-medium">
                      Peacock Cafe,
                      Near Axis Bank,
                      Kodichikkanahalli.
                    </address>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="mt-12 border-t border-gray-100 pt-6">
            <div className="text-center sm:flex sm:justify-between sm:text-left">
              <p className="text-sm text-gray-500">
                <span className="block sm:inline text-black font-medium">Designed and Developed by &nbsp;
                  <a className="text-black hover:text-blue-700 cursor-pointer hover:underline"
                    target="_blank" rel="noreferrer" href="https://makingminds.vercel.app/">Making Minds.</a></span>
              </p>
              <p className="mt-4 text-sm text-gray-800 font-medium sm:order-first sm:mt-0">&copy;  {getYear()} Peacock Cafe . All rights Reserved.</p>
            </div>
          </div>
        </div>
      </footer>

    </div >
  );
};

export default HomePage;
